export default {

  /**
   * Opens a URL in either the Cordova InAppBrowser or the system browser.
   *
   * If the app is running on a mobile device with Cordova support and
   * `showInSystemBrowser` is not set, the URL is opened in the InAppBrowser.
   * Otherwise, `window.open` is used with the provided `target`.
   *
   * @param {string}  url                  - The URL to open.
   * @param {boolean} [showInSystemBrowser=false] - Forces the URL to open in the system browser,
   *                                         even if Cordova is available.
   * @param {string}  [target='_blank']    - Link target for `window.open`
   *                                         (only used in the system browser path).
   * @param {{ event: string, callback: Function }} [event] - Optional event object for the
   *                                         InAppBrowser. Registers an event listener that
   *                                         executes `callback` once `event` fires
   */
  openUrl(url, showInSystemBrowser = false, target = '_blank', event) {
    if (window.cordova && !showInSystemBrowser) {
      window.enodeBrowser =  window.cordova.InAppBrowser.open(url, '_blank', 'location=yes,hideurlbar=yes,hidenavigationbuttons=yes,toolbarposition=top,closebuttoncaption=X,closebuttoncolor=#626262,toolbarcolor=#ffffffff')
      if (event) {
        window.enodeBrowser.addEventListener(event.event, event.callback)
      }
    } else {
      window.open(url, target)
    }
  }
}
